export enum ModalSkeletonSize {
  FULL = 'full',
  SMALL = 'small',
}
